<template>
  <div class="call-holder" :class="{right: right}">
    <small-button large v-on:click="showTel">{{ $nippets.portfolio.call }}</small-button>
    <transition name="fade">
      <div class="call-bubble" v-show="visible">
        <div class="call-speak">{{ $nippets.portfolio.speakLocal }}</div>
        <a :href="'tel:' + mcode" v-on:click="sendEvent">{{ mtel }}</a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    tel: String,
    code: String,
    right: Boolean,
    name: String
  },
  data () {
    return {
      visible: false,
      mtel: '',
      mcode: ''
    }
  },
  created () {
    if(!this.tel) {
      this.mtel = this.$nippets.tel.display
      this.mcode = this.$nippets.tel.code
    }
    else {
      this.mtel = this.tel
      this.mcode = this.code
    }
  },
  methods:{
    showTel: function () {
      this.visible = true
      this.addListener()
    },
    addListener: function () {
      document.body.addEventListener('click', this.eventHandler)
    },
    eventHandler: function (e) {
      if(!this.$el.contains(e.target)){
        this.visible = false
        document.removeEventListener('click', this.eventHandler)
      }
    },
    sendEvent() {
      if(this.name){
        this.$k.sendGaEvent('AgentTracking', 'CallClick', this.$store.state.lang)
      }
      
    }
  }
}
</script>

<style scoped>
  .call-holder{
    position:relative;
    display:inline-block;
    margin-left:5px;
    position:relative;
  }

  .call-bubble{
    position:absolute;
    top:100%;
    padding:14px;
    padding-right:20px;
    border-radius:5px;
    z-index:10;
    white-space: nowrap;
    background-color:#fff;
    box-shadow: 1px 1px 4px #00000066;
    font-weight:400;
    
  }


  .call-bubble a{
    font-weight:500;
    color:#ce0e2d;
    text-decoration:none;
    font-size:21px;
    display:block;
    margin-top:2px;
  }

  .call-bubble a:hover{
    color:#000;
  }

  .right .call-bubble{
    right:0;
  }

  @media screen and (max-width:640px){
    .call-bubble{
      position:fixed;
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      padding:14px;
    }
  }
</style>
